import React from 'react';
import { Table, Tag, Space, Button } from 'antd';
import { PoweroffOutlined, ToolOutlined } from '@ant-design/icons';

const nodeColumns = [
  {
    title: 'Node IP',
    dataIndex: 'ip',
    key: 'ip',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (status: string) => (
      <Tag color={status === 'Healthy' ? 'green' : 'volcano'}>{status.toUpperCase()}</Tag>
    ),
  },
  {
    title: 'CPU Usage',
    dataIndex: 'cpu',
    key: 'cpu',
    render: (cpu: number) => `${cpu}%`,
  },
  {
    title: 'Memory Usage',
    dataIndex: 'memory',
    key: 'memory',
    render: (memory: number) => `${memory}%`,
  },
  {
    title: 'Disk Usage',
    dataIndex: 'disk',
    key: 'disk',
    render: (disk: number) => `${disk}%`,
  },
  {
    title: 'Action',
    key: 'action',
    render: (text: any, record: any) => (
      <Space size="middle">
        <Button icon={<ToolOutlined />}>Cordon</Button>
        <Button danger icon={<PoweroffOutlined />}>Drain</Button>
      </Space>
    ),
  },
];

const nodeData = [
  {
    key: '1',
    ip: '192.168.1.101',
    status: 'Healthy',
    cpu: 30,
    memory: 55,
    disk: 40,
  },
  {
    key: '2',
    ip: '192.168.1.102',
    status: 'Healthy',
    cpu: 45,
    memory: 60,
    disk: 50,
  },
  {
    key: '3',
    ip: '192.168.1.103',
    status: 'Unhealthy',
    cpu: 95,
    memory: 80,
    disk: 75,
  },
    {
    key: '4',
    ip: '192.168.1.104',
    status: 'Maintenance',
    cpu: 0,
    memory: 0,
    disk: 10,
  },
];

const NodeManagement = () => {
  return <Table columns={nodeColumns} dataSource={nodeData} />;
};

export default NodeManagement;
